namespace Nbs.Xlr8PageTemplate.Utilities {
  export function getFirstElement(elementName: string) {
    const elements = document.getElementsByTagName(elementName);
    if (elements.length > 0) {
      return elements[0] as HTMLElement;
    }
    return undefined;
  }

  export function getFirstElementByClass(className: string) {
    const elements = document.getElementsByClassName(className);
    if (elements.length > 0) {
      return elements[0] as HTMLElement;
    }
    return undefined;
  }

  export function hasClass(element: HTMLElement | undefined, className: string) {
    return !!element && element.classList.contains(className);
  }

  export function addClass(element: HTMLElement | undefined, className: string) {
    if (element && !hasClass(element, className)) {
      element.classList.add(className);
    }
  }

  export function removeClass(element: HTMLElement | undefined, className: string) {
    if (element && hasClass(element, className)) {
      element.classList.remove(className);
    }
  }

  export function hasAttribute(element: HTMLElement | undefined, attributeName: string) {
    return !!element && element.hasAttribute(attributeName);
  }

  export function setAttribute(element: HTMLElement | undefined, attributeName: string, value: string) {
    if (element) {
      element.setAttribute(attributeName, value);
    }
  }

  export function removeAttribute(element: HTMLElement | undefined, attributeName: string) {
    if (element) {
      element.removeAttribute(attributeName);
    }
  }

  export function getOrCreateElement(
    elementName: string,
    adjacentElementName: string,
    where: InsertPosition,
    isErrorWhenAdjacentMissing: boolean
  ) {

    const element = getFirstElement(elementName);
    if (element) {
      return element;
    }

    const adjacentElement = getFirstElement(adjacentElementName);
    if (!adjacentElement) {
      if (isErrorWhenAdjacentMissing) {
        throw Error(`adjacent element "${adjacentElementName}" not found, unable to insert "${elementName}"!`);
      }
      return undefined;
    }

    const newElement = document.createElement(elementName);
    adjacentElement.insertAdjacentElement(where, newElement);
    return newElement;
  }

  let currentId = 0;
  export function getNextId() {
    currentId += 1;
    return currentId;
  }

  export function getNewId(idBase: string) {
    return `${idBase}-${getNextId()}`;
  }

  export function replaceChildren(element: HTMLElement | undefined, children: (Node | undefined)[]) {
    if (element) {
      while (element.firstChild) {
        element.removeChild(element.firstChild);
      }
      (children.filter(x => x !== undefined) as Node[]).forEach(x => element.appendChild(x));
    }
  }

  export function stopEvent(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  export function isDisabled(element: HTMLElement) {
    return element.getAttribute('disabled') === 'true' || element.getAttribute('aria-disabled') === 'true';
  }

  export function findParent(startingElement: HTMLElement | null, predicate: (element: HTMLElement) => boolean) {
    let element = startingElement;
    while (element && !predicate(element)) {
      element = element.parentElement;
    }
    return element;
  }
}
